import {MouseEvent} from 'react';
import {Box, Button, ButtonProps, HStack, Tooltip} from '@chakra-ui/react';
import {useTranslation} from 'react-i18next';
import {IconeTemperatureLivraison} from '@/components/IconeTemperatureLivraison';
import {State} from '@synako/halitrek';
import {ClientDesc} from 'api-types/ffconnect-hal';
import {TemperatureDeLivraison} from 'api-types/ffconnect';

export const DateButton: React.FC<{
  date: Date;
  className?: string;
  borderColor?: ButtonProps['borderColor'];
  background?: ButtonProps['background'];
  variant?: ButtonProps['variant'];
  isDisabled?: boolean;
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
  panierEnCours?: boolean;
  commandeExistante?: boolean;
  temperature_tournee?: TemperatureDeLivraison;
  isLoading?: boolean;
  clientBO?: State<ClientDesc>;
}> = ({
  date,
  className,
  borderColor = 'gray.light',
  background = 'transparent',
  variant = 'outline',
  isDisabled = false,
  onClick,
  panierEnCours,
  commandeExistante,
  temperature_tournee,
  isLoading = false,
  clientBO,
}) => {
  const {t} = useTranslation();

  return (
    <Button
      border='1px solid'
      fontSize={{base: 'md', md: 'lg'}}
      fontWeight='700'
      p={{base: 0, md: 'initial'}}
      w='100%'
      minH={{base: '40px', md: '48px'}}
      position='relative'
      className={className}
      borderColor={borderColor}
      background={background}
      variant={variant}
      isDisabled={isDisabled || isLoading}
      onClick={onClick}
      opacity={isLoading ? 0.7 : 1}
    >
      {date.getUTCDate()}
      <HStack
        position='absolute'
        top='0'
        left='0'
        transform='translateX(-30%) translateY(-30%)'
      >
        {temperature_tournee && (
          <IconeTemperatureLivraison
            temperature_tournee={temperature_tournee}
            boxSize={5}
          />
        )}
      </HStack>
      <HStack
        position='absolute'
        bottom='2px'
        left='50%'
        transform='translateX(-50%)'
        spacing={1}
      >
        {panierEnCours && (
          <Tooltip
            label={
              clientBO
                ? t(
                    'back_office.prise_de_commande.liste_clients.panier_commercial_en_cours_tooltip',
                  )
                : t('panier.panier_en_cours')
            }
          >
            <Box
              bg='orange.warning'
              borderRadius='50%'
              boxSize='2'
            />
          </Tooltip>
        )}
        {commandeExistante && (
          <Tooltip
            label={
              clientBO
                ? t(
                    'back_office.prise_de_commande.liste_clients.commande_commercial_existante_tooltip',
                  )
                : t('panier.commande_existant')
            }
          >
            <Box
              bg='green.success'
              borderRadius='50%'
              boxSize='2'
            />
          </Tooltip>
        )}
      </HStack>
    </Button>
  );
};
